<template>
  <div class="content_echarts">
    <!-- <transition name="el-fade-in-linear">
      <div class="curr_tips" :style="{
          left: `${tipconfig.offsetX }px`,
          top: `${tipconfig.offsetY }px`,
        }" v-if="tipconfig.is_show_tips">
        <div class="curr_tip_btn">
          <el-button class="del-btn" @click="deleteData">{{ $t("base.delete") }}</el-button>
        </div>
      </div>
    </transition> -->

    <div class="content_chart">
      <div
        v-if="hclConfig.HCLMode !== onlyCCT"
        class="chart_yname"
      >
        {{ $t("ifttt.lightName") }}（%）
      </div>
      <div id="main_echarts" />
      <div class="chart-tips">
        <ul>
          <li> <i class="el-icon-star-on" />{{ $t('hcl.warning3') }}</li>
          <li><i class="el-icon-star-on" />{{ $t('hcl.warning4') }}</li>
          <li><i class="el-icon-star-on" />{{ $t('hcl.warning5') }}</li>
        </ul>
      </div>
    </div>
    <div class="chart-setbox">
      <div class="curr-tip-sub">
        {{ $t('hcl.hclType') }}
      </div>
      <div class="curr-tip-item">
        <el-radio
          v-model="hclConfig.HCLDimmingMode"
          :label="0"
        >
          {{ $t("hcl.gradient") }} <i :class="[hclConfig.HCLDimmingMode=== 0?'rodio-type curve-act':'rodio-type curve']" />
        </el-radio>
        <el-radio
          v-model="hclConfig.HCLDimmingMode"
          :label="1"
        >
          {{ $t("hcl.jump") }} <i :class="[hclConfig.HCLDimmingMode=== 1?'rodio-type jump-act':'rodio-type jump']" />
        </el-radio>
      </div>

      <div class="curr-tip-sub">
        {{ $t("hcl.argumentType") }}
      </div>
      <div class="curr-tip-item">
        <el-radio
          v-model="hclConfig.HCLMode"
          :label="lightCCT"
        >
          {{ $t("hcl.lightCCT") }}
        </el-radio>
      </div>
      <div class="curr-tip-item">
        <el-radio
          v-model="hclConfig.HCLMode"
          :label="onlylight"
        >
          {{ $t("hcl.onlyLight") }}
        </el-radio>
        <el-radio
          v-model="hclConfig.HCLMode"
          :label="onlyCCT"
        >
          {{ $t("hcl.onlyCCT") }}
        </el-radio>
      </div>

      <template v-if="hclConfig.HCLMode !== onlyCCT">
        <div class="curr-tip-sub">
          {{ $t("ifttt.lightName") }}
        </div>
        <div class="curr-tip-item">
          <div class="slider_width">
            <div class="slider_percent input_slider ">
              <el-slider
                v-model="tipconfig.Bright"
                :min="minLight"
                :max="100"
                show-input
                @change="ctrltypechange($event,1)"
              />
            </div>
          </div>
          &nbsp;%
        </div>
      </template>

      <template v-if="hclConfig.HCLMode !== onlylight">
        <div class="curr-tip-sub">
          {{ $t("hcl.colorName") }}
        </div>
        <div class="curr-tip-item">
          <div class="slider_width">
            <div class="slider_percent input_slider hcl-slider">
              <el-slider
                v-model="tipconfig.CCT"
                :min="$store.state.colorTemperatureRange.Min"
                :max="$store.state.colorTemperatureRange.Max"
                show-input
                @change="ctrltypechange($event,2)"
              />
            </div>
          </div>
          &nbsp;K
        </div>
      </template>

      <div class="curr_tip_btn">
        <el-button
          class="del-btn"
          @click="deleteData"
        >
          {{ $t("base.delete") }}
        </el-button>
        <!-- <el-button @click="deleteData">{{ $t("base.delete") }}</el-button> -->
        <!-- <el-button @click="Confirmbtn">{{ $t("base.save") }}</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import moment from 'moment'
import { myFixed } from '@/utils/utils'

export default {
  props: {
    timeList: {
      type: Array,
      default () {
        return []
      }
    },
    isShowLabel: {
      type: Boolean,
      default: false
    },
    configList: {
      type: Object,
      default: {}
    },
    oldTimeList: {
      type: Array,
      default () {
        return []
      }
    },
    intervalTime: {
      type: Number,
      default: 60
    },
    minLight:{
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      selfLight:[26,51,76],
      lightCCT: 3, // 亮度+色温
      onlylight: 1, // 仅亮度
      onlyCCT: 2, // 仅色温
      echartsObj1: null, // 自定义灯具echarts
      //  点击echarts弹框配置信息
      tipconfig: {
        is_show_tips: false,
        offsetX: 0,
        offsetY: 0,
        tipboottom: 0,
        Bright: this.minLight,
        CCT: this.$store.state.colorTemperatureRange.Min
      },
      tip_bottom_type: 0, // 定义tip三角形的位置。1代表左上角，2代表右上角，3代表左边，4代表右边 5 中间上面 6，默认中间
      base_date: '2022-01-01', // 定义一个基础时间，用于echarts横坐标显示
      base_date1: '2022-01-02', // 跨天24小时
      currindex: null,
      colorList: ['#ffa013', '#ffbb53', '#fed799', '#fef1da', '#f9f7f3', '#f6f6f6', '#f1f5fb', '#eef5ff', '#deeaff', '#d6e5ff', '#c6dcff', '#bbd6ff'], //['#FFE88A', '#FFF7BA', '#FFFBE4', '#FFFFFF', '#EAF7FF', '#C8EFFF', '#9AE2FF'], // 渐变颜色
      hclConfig: {
        HCLDimmingMode: this.configList.HCLDimmingMode,
        HCLMode: this.configList.HCLMode
      },
      deepCloneTimeList: this.timeList
    }
  }, // echarts选中数据集合，
  computed: {
    getStampList () {
      if (this.deepCloneTimeList.length) {
        const arr = this.deepCloneTimeList.map(function (item) {
          return item.value[0]
        })
        return arr
      } else {
        return []
      }
    },
    xAxisData () {
      if (this.deepCloneTimeList.length) {
        const arr = []
        for (let index = 1; index < this.deepCloneTimeList.length - 1; index++) {
          arr.push(this.deepCloneTimeList[index].value[0])
        }
        return arr
      } else {
        return []
      }
    },
    xAxisDatalabel () {
      if (this.deepCloneTimeList.length) {
        const arr = []
        for (let index = 1; index < this.deepCloneTimeList.length - 1; index++) {
          arr.push({ xAxis: this.deepCloneTimeList[index].value[0] })
        }
        return arr
      } else {
        return []
      }
    },
    yAxisLabelShow () {
      if (this.hclConfig.HCLMode === this.onlyCCT) {
        return false
      } else {
        return true
      }
    },
    areaColor () {
      return this.changeAreaColor()
    },
    visualMapPiecewise () {
      return this.changeVisualMapPiecewise()
    }
  },
  watch: {
    isShowLabel: function (val) {
      this.changeIsShowLabel(val)
    },
    'hclConfig.HCLMode': {
      immediate: true,
      handler (val) {
        this.$nextTick(() => {
          if (val === this.onlyCCT) {
            this.deepCloneTimeList.forEach(item => {
              item.value[1] = 100
            })

            this.echartsObj1.setOption({
              yAxis: {
                axisLabel: {
                  show: false
                }
              }
            })
          } else {
            this.deepCloneTimeList.forEach(item => {
              item.value[1] = item.Bright
            })
            this.echartsObj1.setOption({
              yAxis: {
                axisLabel: {
                  show: true
                }
              }
            })
          }
          this.setOptionEcharts()
          this.formatTimeList()
        })
      }
    },
    'hclConfig.HCLDimmingMode': function () {
      this.echartsObj1.clear()
      this.createdInit()
      this.formatTimeList()
    }
  },
  mounted () {
    this.createdInit()
    // 监听删除键
    document.onkeydown = (e) => {
      if (this.currindex == null) {
        return
      }
      const inputList = document.getElementsByTagName('input')
      let is_foucs = false
      // 判断删除时候input是否在聚焦状态，如果在聚焦状态则触发按下delete键删除节点。
      for (let index = 0; index < inputList.length; index++) {
        if (inputList[index] == document.activeElement) {
          is_foucs = true
          break
        }
      }
      if (e.keyCode == 8 && !is_foucs) {
        this.deleteData()
      }
    }
    // 监听窗口改变
    window.onresize = () => {
      this.echartsObj1.resize()
      this.setOptionEcharts()
    }
  },
  // 销毁
  destroyed () {
    // 销毁监听
    document.onkeydown = null
    window.onresize = null
    this.echartsObj1 = null
  },
  methods: {
    changeIsShowLabel (val) {
      this.setOptionEcharts()
    },
    changeAreaColor () {
      try {
        let result = new echarts.graphic.LinearGradient(1, 0, 0, 0, [])
        if (this.deepCloneTimeList.length) {
          for (let index = 0; index < this.deepCloneTimeList.length; index++) {
            const colorItem = this.hclConfig.HCLMode === this.onlylight ? this.lightToColor(this.deepCloneTimeList[index].value[1]) : this.CCTtoColor(this.deepCloneTimeList[index].CCT)
            let time = this.deepCloneTimeList.length - 1 === index
              ? 0
              : Number(myFixed(1 - Number(myFixed(moment(this.deepCloneTimeList[index].value[0]).hours() / 24, 3)), 3))
            const hasMin = moment(this.deepCloneTimeList[index].value[0]).minute() > 0
            time = time * 100 < 50 && time !== 1 && time !== 0 && time * 100 > 5 && hasMin ? (time * 100 - 5) / 100 : time
            time = myFixed(time, 2) || '1.00'
            result.colorStops.push({
              offset: time,
              color: colorItem
            })
          }
        } else {
          result = '#fff'
        }
        return result
      } catch (error) {
      }
    },
    changeVisualMapPiecewise () {
      const result = []
      if (this.deepCloneTimeList.length) {
        for (let i = 0; i < this.deepCloneTimeList.length; i++) {
          let colorItem, minTime, maxTime
          colorItem = this.hclConfig.HCLMode === this.onlylight ? this.lightToColor(this.deepCloneTimeList[i].value[1]) : this.CCTtoColor(this.deepCloneTimeList[i].CCT)
          minTime = this.deepCloneTimeList[i].value[0]
          maxTime = this.deepCloneTimeList.length - 1 === i ? this.deepCloneTimeList[i].value[0] : this.deepCloneTimeList[i + 1].value[0]

          /* maxTime - 1为了显示的颜色界限滞后 */
          result.push({
            min: minTime,
            max: maxTime - 1,
            color: colorItem
          })
        }
      }

      return result
    },
    createdInit () {
      const symbolSize = 14
      const data = []

      this.echartsObj1 = echarts.init(
        document.getElementById('main_echarts')
      )
            const option = {
        title: {
          text: '',
          show: false
        },
        tooltip: {
          formatter: () => {
            return ''
          }
        },
        animation: false,
        grid: {
          top: '15%',
          left: '5%',
          right: '10%',
          bottom: '9%',
          containLabel: true
        },
        xAxis: {
          name: `${this.$t('ifttt.time')}(h)`,
          data: this.xAxisData,
          min: `${this.base_date} 00:00:00`,
          max: `${this.base_date1} 00:00:00`,
          type: 'time',
          splitNumber: 24,
          minInterval: 60 * 1000,
          maxInterval: 3600 * 24 * 1000,
          axisLine: { onZero: false },
          axisLabel: {
            margin: 15,
            fontSize: 12,
            formatter: (value) => {
              // 2022-01-02 返24小时
              if (moment(value).format('YYYY-MM-DD') === '2022-01-02') {
                return 24
              }
              return this.formateDate(value, 'hh')
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        yAxis: {
          min: this.minLight,
          max: 100,
          splitNumber: 4,
          interval: 25,
          nameTextStyle: {
            color: '#85888e'
          },
          type: 'value',
          axisLine: { show: false, onZero: false },
          axisTick: { show: false },
          axisLabel: {
            show: this.yAxisLabelShow,
            formatter: (value) => {
              if(this.selfLight.indexOf(value) != -1){
                value -= 1
              }
              return `${value}%`
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'solid'
            }
          }
        },
        series: [
          {
            id: 'a',
            type: 'line',
            symbol: 'circle', // 折点的形状
            symbolSize,
            data: this.deepCloneTimeList,
            label: {
              show: this.isShowLabel,
              formatter: (value) => {
                return this.hclConfig.HCLMode === this.lightCCT ? `{title|${this.$t('ifttt.lightName')}}:${value.data.Bright}%\n{title|${this.$t('hcl.colorName')}}:${value.data.CCT}K` : this.hclConfig.HCLMode === this.onlylight ? `{title|${this.$t('ifttt.lightName')}}:${value.data.Bright}%` : `{title|${this.$t('hcl.colorName')}}:${value.data.CCT}K`
              },
              rich: {
                title: {
                  color: '#000',
                  height: 16,
                  align: 'cetner'
                }
              },
              backgroundColor: '#fff',
              borderColor: 'rgba(0, 0, 0, .1)',
              borderWidth: 1,
              borderRadius: 2,
              color: '#000',
              padding: [6, 6, 6, 6]
            },
            lineStyle: { // 折线的样式配置
              width: 2,
              color: '#2A72EA'
            },
            itemStyle: {
              normal: {
                color: '#fff',
                borderColor: '#2A72EA',
                borderWidth: 1,
                borderRadius: 10,
                shadowColor: 'rgba(0, 0, 0, .6)', // 阴影颜色
                // shadowBlur: 0,  // 阴影模糊度
                shadowOffsetY: 0.5 // 阴影在Y轴上的偏移
                // shadowOffsetX: 1, // X轴的偏移
              }
            },
            emphasis: {
              itemStyle: {
                show: false,
                borderWidth: 3
              }
            },
            universalTransition: {
              enabled: false
            },
            markLine: {
              symbol: ['none', 'none'], // 去掉箭头
              silent: true,
              itemStyle: {
                normal: {
                  lineStyle: {
                    // type: 'dash',
                    // color: "#fff",
                    // borderWidth: 2
                    opacity: 0
                  },
                  label: {
                    show: true,
                    position: 'start',
                    distance: 30,
                    formatter: (params) => {
                      const date = params.data.value
                      const date_time = this.formateDate(date)
                      return `{b|${date_time}}`
                    },
                    rich: {
                      b: {
                        color: '#fff',
                        backgroundColor: '#2A72EA',
                        width: 50,
                        height: 20,
                        borderRadius: 10
                      }
                    }
                  }
                }
              },
              data: this.xAxisDatalabel
            }
          }
        ]
      }

      // 增加点
      const zr = this.echartsObj1.getZr()
      zr.off('dblclick')
      zr.off('click')
      zr.on('dblclick', (params) => {
        // this.echartsObj1.off('dblclick');
        // 关闭弹框
        this.tipconfig = {
          is_show_tips: false
        }
        const pointInPixel = [params.offsetX, params.offsetY]
        const pointInGrid = this.echartsObj1.convertFromPixel(
          'grid',
          pointInPixel
        )

        if (this.echartsObj1.containPixel('grid', pointInPixel)) {
          const temp_timestamp = this.getNowMinutesStamp(pointInGrid[0])
          const temp_bright = +pointInGrid[1].toFixed(0)
          // 如果存在相同的点。就给加到10秒以后
          if (this.getStampList.indexOf(temp_timestamp) != -1) {
            return
          } else {
            if (temp_timestamp == this.gettimeStamp(`${this.base_date} 00:00:00`)) {
              return
            }
            
            // 国外10个上限
            if (!this.$store.state.isNoLimit && this.deepCloneTimeList.length === 12) {
              this.$message({
                type: 'warning',
                message: this.$t('ifttt.maxConfigMessage')
              })
              return
            }
            // 国内 30个上限
            if (this.$store.state.isNoLimit && this.deepCloneTimeList.length === 32) {
              this.$message({
                type: 'warning',
                message: this.$t('ifttt.maxConfigMessage30')
              })
              return
            }
            let start_time = temp_timestamp
            if (start_time < this.gettimeStamp(`${this.base_date} 00:00:00`)) {
              start_time = this.gettimeStamp(`${this.base_date} 00:00:00`)
            }
            // let end_time = temp_timestamp + (10 * 60 * 1000);
            let temp_arr = []
            this.currindex = null
            temp_arr = [temp_timestamp, temp_bright]

            if (this.hclConfig.HCLMode === this.onlyCCT) {
              temp_arr = [temp_timestamp, 100]
            }

            for (let i = 0; i < this.deepCloneTimeList.length; i++) {
              if (this.deepCloneTimeList[i].value[0] > temp_timestamp) {
                // 判断亮点之间的距离
                if (i > 1) {
                  if (this.deepCloneTimeList[i].value[0] - start_time < this.minIntervalTime() || start_time - this.deepCloneTimeList[i - 1].value[0] < this.minIntervalTime()) {
                    this.$message({
                      type: 'warning',
                      message: this.$t('ifttt.configWarnMessage')
                    })
                    break
                  }
                }

                this.currindex = i
                // 判断当前点击位置前后两个点的
                if (start_time >= this.deepCloneTimeList[i - 1].value[0]) {
                  this.deepCloneTimeList.splice(i, 0, {
                    value: temp_arr,
                    Bright: temp_bright,
                    CCT: this.$store.state.colorTemperatureRange.Min
                  })
                  break
                }
              }
            }
          }
          if (this.currindex != null) {
            this.createdInit()
            this.setOptionEcharts()
            // 出现弹框
            this.showAlert(true, params)
            this.showHighLight(this.currindex)
            this.formatTimeList()
          }
        }
      })

      zr.on('click', (param) => {
        // 没有选中节点关闭弹窗
        if (param.target === undefined) {
          this.hideHighLight()
          this.closeCuurTip()
        }
      })
      zr.on('mousemove', function (params) {
        // var pointInPixel = [params.offsetX, params.offsetY];
        if (params.cancelBubble !== undefined) {
          zr.setCursorStyle('copy')
        }
      })

      this.echartsObj1.setOption(option)
      setTimeout(() => {
        this.setOptionEcharts()
      }, 0)
    },
    minIntervalTime () {
      return this.intervalTime * 60 * 1000
    },
    // 时间戳转化为hh:mm
    formateDate (timestamp, format = 'hh:mm') {
      return echarts.format.formatTime(format, timestamp)
    },
    // 获取日期的时间戳
    gettimeStamp (time) {
      return new Date(time.replace(/-/g, '/')).getTime()
    },
    // 关闭弹框
    closeCuurTip () {
      // this.tipconfig = {
      //   is_show_tips: false,
      // };
      this.currindex = null
      this.tipconfig.Bright = this.minLight
      this.tipconfig.CCT = 0
    },
    setOptionEcharts () {
      try {
        const symbolSize = 14
        const option = {
          graphic: this.deepCloneTimeList.map((item, dataIndex, arr) => {
            return {
              type: 'circle',
              position: this.echartsObj1.convertToPixel('grid', item.value),
              shape: {
                cx: 0,
                cy: 0,
                r: symbolSize / 2
              },
              invisible: true,
              draggable: true,
              ondrag: (params) => {
                this.onPointDragging(dataIndex, [params.offsetX, params.offsetY])
              },
              ondragstart: (params) => {
                this.currindex = dataIndex
                this.hideHighLight()
                this.showHighLight(dataIndex)
                params.stop()
              },
              ondragend: (params) => {
                this.onPointDraggEnd(dataIndex, [params.offsetX, params.offsetY])
              },
              onmousemove: () => {
                this.showTooltip(dataIndex)
              },
              onclick: (params) => {
                this.currindex = dataIndex
                this.hideHighLight()
                this.showHighLight(dataIndex)
                this.deleteConfirm(dataIndex, params)
              },
              onmouseout: () => {
                this.hideTooltip(dataIndex)
              },
              z: 100
            }
          })
        }

        if (this.configList.HCLDimmingMode !== 1) {
          option.series = [
            {
              id: 'a',
              smooth: true, // 折线圆润
              data: this.deepCloneTimeList,
              label: {
                show: this.isShowLabel
              },
              areaStyle: {
                color: this.areaColor
              }
            }
          ]
        } else {
          option.visualMap = {
            type: 'piecewise',
            show: false,
            dimension: 0,
            pieces: this.visualMapPiecewise
          }
          option.series = [
            {
              id: 'a',
              smooth: false,
              step: 'end', // 切换梯形图
              data: this.deepCloneTimeList,
              label: {
                show: this.isShowLabel
              },
              areaStyle: {}
            }
          ]
        }

        this.echartsObj1.setOption(option)
      } catch (err) { }
    },
    // 获取时60分钟后时间戳正点时间
    getbeforeTenMinutesStamp (timestamp) {
      const temp_timestamp = timestamp - this.intervalTime * 60 * 1000
      const str_time = this.formateDate(temp_timestamp)
      return this.gettimeStamp(`${this.base_date} ${str_time}:00`.replace(/-/g, '/'))
    },
    // 获取时60分钟后时间戳正点时间
    getNowMinutesStamp (timestamp) {
      const str_time = this.replaceStr1(this.formateDate(timestamp))
      return this.gettimeStamp(`${this.base_date} ${str_time}:00`.replace(/-/g, '/'))
    },
    // 获取时60分钟后时间戳正点时间
    getTenMinutesStamp (timestamp) {
      const temp_timestamp = timestamp + this.intervalTime * 60 * 1000
      const str_time = this.formateDate(temp_timestamp)
      return this.gettimeStamp(`${this.base_date} ${str_time}:00`.replace(/-/g, '/'))
    },
    // 替换字符串
    replaceStr1 (str, index, char) {
      const strAry = str.split('')
      strAry[index] = char
      return strAry.join('')
    },
    CCTtoColor (number) {
      // const CCT = number
      let color = ''

      const all = this.$store.state.colorTemperatureRange.Max - this.$store.state.colorTemperatureRange.Min;
      const singleArea = Math.floor(all / 12);
      const curNumber = number - this.$store.state.colorTemperatureRange.Min;

      const i = Math.min(Math.floor(curNumber / singleArea), 11);

      return this.colorList[i]

      // switch (true) {
      //   case CCT >= this.$store.state.colorTemperatureRange.Min && CCT < 3000:
      //     color = this.colorList[0]
      //     break
      //   case CCT >= 3000 && CCT < 3500:
      //     color = this.colorList[1]
      //     break
      //   case CCT >= 3500 && CCT < 4000:
      //     color = this.colorList[2]
      //     break
      //   case CCT >= 4000 && CCT < 5000:
      //     color = this.colorList[3]
      //     break
      //   case CCT >= 5000 && CCT < 5500:
      //     color = this.colorList[4]
      //     break
      //   case CCT >= 5500 && CCT < 6000:
      //     color = this.colorList[5]
      //     break
      //   case CCT >= 6000 && CCT <= this.$store.state.colorTemperatureRange.Max:
      //     color = this.colorList[6]
      //     break
      //   default:
      //     color = '#fff'
      //     break
      // }
      return color
    },
    lightToColor (number) {
      const light = number
      let color = ''
      switch (true) {
        case light === 0:
          color = '#000'
          break
        case light > 0 && light <= 10:
          color = '#1a1a1a'
          break
        case light > 10 && light <= 20:
          color = '#333333'
          break
        case light > 20 && light <= 30:
          color = '#4d4d4d'
          break
        case light > 30 && light <= 40:
          color = '#666666'
          break
        case light > 40 && light <= 50:
          color = '#808080'
          break
        case light > 50 && light <= 60:
          color = '#999999'
          break
        case light > 60 && light <= 70:
          color = '#b3b3b3'
          break
        case light > 70 && light <= 80:
          color = '#cccccc'
          break
        case light > 80 && light <= 90:
          color = '#e5e5e5'
          break
        case light > 90 && light <= 100:
          color = '#ffffff'
          break
        default:
          color = 'fff'
          break
      }

      return color
    },
    showHighLight (dataIndex) {
      this.echartsObj1.dispatchAction({
        type: 'highlight',
        seriesIndex: 0,
        dataIndex
      })
    },
    hideHighLight (dataIndex) {
      this.echartsObj1.dispatchAction({
        type: 'downplay',
        dataIndex
      })
    },
    showTooltip (dataIndex) {
      this.echartsObj1.dispatchAction({
        type: 'showTip',
        seriesIndex: 0,
        dataIndex
      })
    },
    hideTooltip (dataIndex) {
      this.echartsObj1.dispatchAction({
        type: 'hideTip'
      })
    },
    onPointDragging (dataIndex, pos) {
      const pointInGrid = this.echartsObj1.convertFromPixel('grid', pos)
      const startTime = this.gettimeStamp(`${this.base_date} 00:00:00`)
      const endTime = this.gettimeStamp(`${this.base_date1} 00:00:00`)
      let temp_bright, temp_time

      // 亮度拖拽范围
      if (pointInGrid[1] <= this.minLight) {
        temp_bright = this.minLight
      } else if (pointInGrid[1] >= 100 || this.hclConfig.HCLMode === this.onlyCCT) {
        temp_bright = 100
      } else {
        temp_bright = pointInGrid[1]
      }

      // 时间拖拽范围
      if (pointInGrid[0] <= startTime) {
        temp_time = startTime
      } else if (pointInGrid[0] >= endTime) {
        temp_time = endTime
      } else {
        temp_time = pointInGrid[0]
      }

      const changeTempBright = (index) => {
        this.deepCloneTimeList[index].value = [this.deepCloneTimeList[index].value[0], temp_bright]
        this.deepCloneTimeList[index].Bright = +temp_bright.toFixed(0)
      }

      // 第一个点和最后个点的数据只能改变亮度无法改变时间
      if (dataIndex == 0 || dataIndex == this.deepCloneTimeList.length - 1) {
        changeTempBright(0)
        changeTempBright(this.deepCloneTimeList.length - 1)
      } else {
        this.deepCloneTimeList[dataIndex].Bright = +temp_bright.toFixed(0)
        // Update data
        this.deepCloneTimeList[dataIndex].value = [temp_time, temp_bright]
      }

      this.tipconfig.Bright = this.deepCloneTimeList[dataIndex].Bright
      this.tipconfig.CCT = this.deepCloneTimeList[dataIndex].CCT
      this.setOptionEcharts()
      // this.createdInit();
    },
    // 删除点
    deleteConfirm (dataIndex, params) {
      this.showAlert(false, params)
      // if (this.currindex == 0 || ((this.currindex + 1) == this.deepCloneTimeList.length)) {
      //   this.tipconfig.is_show_tips = false;
      // }
    },
    deleteData () {
      if (!this.currindex) {
        return
      }
      if (this.currindex == 0 || this.currindex + 1 == this.deepCloneTimeList.length) {
        return
      }
      this.deepCloneTimeList.splice(this.currindex, 1)
      this.hideHighLight(this.currindex)
      this.echartsObj1.clear()// 删除后需要重置画布不然会造成index不重置的问题
      this.createdInit()
      this.setOptionEcharts()
      this.formatTimeList()
      this.closeCuurTip()
    },
    onPointDraggEnd (dataIndex, pos) {
      const pointInGrid = this.deepCloneTimeList[dataIndex].value
      // let pointInGrid = this.echartsObj1.convertFromPixel("grid", pos);
      let temp_bright = pointInGrid[1]
      if (temp_bright <= 0) {
        temp_bright = this.minLight
      } else if (temp_bright >= 100) {
        temp_bright = 100
      }

      const start_date = this.gettimeStamp(`${this.base_date} 01:00:00`)
      const end_date = this.gettimeStamp(`${this.base_date} 23:00:00`)
      if (dataIndex === 1 && pointInGrid[0] < start_date) {
        const timestamp = start_date
        const temp_arr = [timestamp, temp_bright]
        this.deepCloneTimeList[dataIndex].value = temp_arr
      } else if (dataIndex === this.deepCloneTimeList.length - 2 && pointInGrid[0] > end_date) {
        const timestamp = end_date
        const temp_arr = [timestamp, temp_bright]
        this.deepCloneTimeList[dataIndex].value = temp_arr
      } else if (this.deepCloneTimeList[dataIndex - 1] && pointInGrid[0] - this.deepCloneTimeList[dataIndex - 1].value[0] != 0 && pointInGrid[0] - this.deepCloneTimeList[dataIndex - 1].value[0] < this.minIntervalTime()) {
        const after_timestamp = this.getTenMinutesStamp(
          this.deepCloneTimeList[dataIndex - 1].value[0]
        )
        const temp_arr = [after_timestamp, temp_bright]
        this.deepCloneTimeList[dataIndex].value = temp_arr
      } else if (this.deepCloneTimeList[dataIndex + 1] && this.deepCloneTimeList[dataIndex + 1].value[0] - pointInGrid[0] < this.minIntervalTime()) {
        const before_timestamp = this.getbeforeTenMinutesStamp(
          this.deepCloneTimeList[dataIndex + 1].value[0]
        )
        const temp_arr = [before_timestamp, temp_bright]
        this.deepCloneTimeList[dataIndex].value = temp_arr
      } else {
        const timestamp = pointInGrid[0]
        const temp_arr = [timestamp, temp_bright]
        this.deepCloneTimeList[dataIndex].value = temp_arr
      }

      this.deepCloneTimeList[dataIndex].Bright = +temp_bright.toFixed(0)

      this.formatTimeList()
      this.createdInit()
    },
    showAlert (is_create, params = {}) {
      this.tipconfig = {
        is_show_tips: false
      }
      const pointInPixel = [params.offsetX, params.offsetY]
      // 获取echarts高度，宽度，鼠标点击x，y轴的坐标像素
      const echartsWidth = this.echartsObj1.getWidth()
      // let echartsHeight = this.echartsObj1.getHeight();
      const ClickOffsetX = params.offsetX + 10
      const ClickOffsetY = params.offsetY + 10
      let tip_offsetX, tip_offsetY, tip_type

      tip_offsetX = ClickOffsetX
      tip_offsetY = ClickOffsetY
      // 判断是创建还是更新
      let temp_Bright, temp_CCT
      if (is_create) {
        const pointInGrid = this.echartsObj1.convertFromPixel(
          'grid',
          pointInPixel
        )

        temp_Bright = Number(pointInGrid[1].toFixed(0))
        temp_CCT = this.$store.state.colorTemperatureRange.Min
      } else {
        temp_Bright = this.deepCloneTimeList[this.currindex].Bright
        temp_CCT = this.deepCloneTimeList[this.currindex].CCT
      }

      this.tipconfig = {
        is_show_tips: true,
        offsetX: tip_offsetX,
        offsetY: tip_offsetY,
        tip_bottom_type: tip_type,
        Bright: temp_Bright,
        CCT: temp_CCT
      }
    },
    /* 改变颜色执行的方法
      * type 类型 1是亮度 2是色温
      * event 值
      */
    ctrltypechange (event, type) {
      this.tipconfig.is_show_tips = false
      if (this.currindex || this.currindex === 0) {
        let isType
        if (type === 1) {
          isType = this.deepCloneTimeList[this.currindex].Bright > event
        }
        this.Confirmbtn(isType)
      }
    },
    Confirmbtn (isType) {
      const temp_bright = Number(this.tipconfig.Bright)
      const changeTempBrightCCT = (index) => {
        this.deepCloneTimeList[index].value = [this.deepCloneTimeList[index].value[0], temp_bright]
        this.deepCloneTimeList[index].Bright = +Number(temp_bright.toFixed(0))
        this.deepCloneTimeList[index].CCT = this.tipconfig.CCT
      }

      // 坐标圆点首尾联动
      if (this.currindex === 0 || this.currindex === this.deepCloneTimeList.length - 1) {
        changeTempBrightCCT(0)
        changeTempBrightCCT(this.deepCloneTimeList.length - 1)
      } else {
        this.deepCloneTimeList[this.currindex].Bright = temp_bright
        this.deepCloneTimeList[this.currindex].value = [this.deepCloneTimeList[this.currindex].value[0], temp_bright]
      }

      this.deepCloneTimeList[this.currindex].CCT = this.tipconfig.CCT
      this.changeAreaColor()
      this.setOptionEcharts()
      this.formatTimeList()
    },
    formatTimeList () {
      const emitData = {}
      const data = []
      this.deepCloneTimeList.forEach((item, index) => {
        let time_start = this.formateDate(item.value[0])

        if (index === this.deepCloneTimeList.length - 1) {
          time_start = '24:00'
        }

        data.push({
          Bright: item.Bright,
          CCT: item.CCT,
          time: time_start
        })
      })

      emitData.timneList = data
      emitData.configList = this.hclConfig

      this.$emit('changeTimeList', emitData)
    }
  }
}
</script>
<style lang="scss" scoped>
.content_echarts {
  width: 100%;
  height: 100%;
  position: relative;
  .content_chart {
    position: relative;
    width: 70%;
    height: 100%;
    float: left;
    padding-left: 40px;
    box-sizing: border-box;
  }
  .chart_yname {
    position: absolute;
    top: 210px;
    left: 0px;
    transform: rotate(270deg);
  }
  .curr-tip-item {
    display: flex;
    align-items: center;
    line-height: 40px;
    height: 40px;
    .curr_tip_label {
      margin-left: 20px;
    }
    .slider_width {
      width: 100%;
    }
    .slider_width .slider_percent {
      width: 100% !important;
      margin-left: 0;
    }
  }

  .hcl-slider ::v-deep .el-slider__runway {
    background: linear-gradient(90deg, #ff7e00 0%, #ffe36d 9%, #fffaf1 33%, #faf9f8 38%, #f5f9ff 44%, #bbd6ff 100%);
  }

  .hcl-slider ::v-deep .el-slider__bar {
    background-color: transparent;
  }

  .curr-tip-sub {
    line-height: 40px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
  }
  .curr-tip-item_line {
    border-bottom: 1px solid #e5e5e5;
  }
  .curr_tips {
    position: absolute;
    z-index: 9999;
    .close_tip_icon {
      float: right;
    }

    ::v-deep .second_tab_cont {
      height: 315px !important;
    }

    ::v-deep .curr_tip_input {
      width: 80px;
      margin-left: 10px;
      input {
        height: 24px !important;
        padding: 0;
      }
    }
    ::v-deep .curr_color_label {
      margin-left: 56px;
      display: flex;
      align-items: center;
      .el-icon-close:hover {
        animation: normal !important;
      }
    }
  }

  .curr_tip_btn {
    margin-top: 20px;
    ::v-deep .del-btn {
      span {
        color: #606266 !important;
      }
    }
  }
}

.chart-setbox {
  width: 30%;
  float: left;
  margin-top: 20px;
  padding-left: 30px;
  box-sizing: border-box;
}
.chart-tips {
  line-height: 25px;
  margin-left: 30px;
  font-size: 12px;
  .el-icon-star-on {
    font-size: 5px;
    color: #2a72ea;
    margin-right: 10px;
    transform: scale(0.7);
  }
}

.curr_tips::after {
  content: "";
  position: absolute;
  border: 0px solid transparent;
}

.curr_tips_left::after {
  border-top-color: #fff;
  top: 10px;
  left: 35px;
}

.curr_tips_right::after {
  border-top-color: #fff;
  top: 50%;
  right: 35px;
}

.curr_tips_center::after {
  border-top-color: #fff;
  top: 50%;
  left: 195px;
}

.curr_tips_left_top::after {
  border-bottom-color: #fff;
  // bottom: 50%;
  top: 50%;
  left: 35px;
}

.curr_tips_right_top::after {
  border-bottom-color: #fff;
  bottom: 50%;
  right: 35px;
}

.curr_tips_center_top::after {
  border-bottom-color: #fff;
  bottom: 100%;
  left: 195px;
}

#main_echarts {
  width: 100%;
  height: 100%;
}

.main_tooltip {
  font-size: 12px;
}

.rodio-type {
  display: inline-block;
  width: 19px;
  height: 11px;
}
.curve {
  background: url("~@/assets/img/rhythm/curve@2x.png") no-repeat;
  background-size: 100% 100%;
}
.jump {
  background: url("~@/assets/img/rhythm/jump@2x.png") no-repeat;
  background-size: 100% 100%;
}

.curve-act {
  background: url("~@/assets/img/rhythm/curve-act@2x.png") no-repeat;
  background-size: 100% 100%;
}

.jump-act {
  background: url("~@/assets/img/rhythm/jump-act@2x.png") no-repeat;
  background-size: 100% 100%;
}

.tooltips-line {
  border: 1px dotted #fff;
}

::v-deep .el-radio {
  display: flex;
}
::v-deep .is-checked {
}
::v-deep .el-radio__input {
  border: 1px solid #333;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  display: flex;
}
::v-deep .el-radio__inner {
  border: 3px solid #fff !important;
  width: 12px;
  height: 12px;
  margin: 0;
}
</style>
